import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quantity-container__quantity" }
const _hoisted_2 = { class: "quantity-container__fulfilled" }
const _hoisted_3 = { class: "quantity-container__partial" }
const _hoisted_4 = { class: "quantity-container__quantity quantity-container__quantity--expanded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quantity-container", { disabled: _ctx.displayDisabled }])
  }, [
    (!_ctx.partial)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.quantity ?? _ctx.placeholder), 1)
        ], true)
      : (_ctx.quantity === 0)
        ? _renderSlot(_ctx.$slots, "fulfilled", { key: 1 }, () => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.partial), 1)
          ], true)
        : _renderSlot(_ctx.$slots, "expanded", { key: 2 }, () => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.partial), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.quantity), 1)
          ], true)
  ], 2))
}